import React from "react";

import styles from "./PageSection.module.css";

export const PageSection = ({
  children,
  variant,
  className,
  ...props
}) => {
  const variantClass = variant ? styles[variant] : "";
  const classes = [
    styles.pageSection,
    variantClass,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};
